import React, { useState } from "react";
import { Form } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

// Guidance scale, or CFG Scale, refers to how closely the generated image
// follows the supplied prompt.

/**
 * Component for the guidance scale widget
 * Sends the data back to the generator using the parentCallback function
 * @param {*} props
 * @returns
 */
export default function GuidanceScale(props) {
  return (
    <div>
      <span>
        Guidance Scale
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="tooltip-disabled">
              Choose the guidance scale or how closely the generator follows
              your prompt
            </Tooltip>
          }
        >
          <span style={{ marginLeft: "0.5vw" }}>ⓘ</span>
        </OverlayTrigger>
      </span>
      {/* Update CFG if either text box or slider input is changed */}
      <Form.Control
        id="GuidanceScale"
        value={props.guidance}
        onChange={(e) => props.setGuidance(parseFloat(e.target.value))}
      ></Form.Control>
      <Form.Range value={props.guidance} onChange={(e) => props.setGuidance(parseFloat(e.target.value))} />
    </div>
  );
}
